<template>
  <div>
    <div>
      <DropDown v-model="subInvoice" :options="SUB_INVOICES" optionLabel="name" @change="dataInput = subInvoice.data" />
      <Button label="Uppdatera faktura" icon="pi pi-plus" @click="updateInvoice()" />
      <pre v-if="dataOutput">
        {{ dataOutput | toJSON }}
      </pre>
    </div>
    <div v-if="dataInput">
      <json-editor :data-input="dataInput" @data-output="(data) => (dataOutput = data)"> </json-editor>
    </div>
  </div>
</template>

<script>
import JsonEditor from '@kassaila/vue-json-editor'
import Button from 'primevue/button'
import DropDown from 'primevue/dropdown'

import { mapGetters } from 'vuex'

export default {
  name: 'InvoiceSubContractorEdit',
  components: {
    JsonEditor,
    Button,
    DropDown
  },
  data () {
    return {
      subInvoice: {},
      dataInput: null,
      dataOutput: null
    }
  },
  async mounted () {
    await this.$store.dispatch('GET_SUB_INVOICES')
  },
  computed: {
    ...mapGetters(['SUB_INVOICES'])
  },
  methods: {
    async updateInvoice () {
      await this.$store.dispatch('UPDATE_SUB_INVOICE', {
        id: this.subInvoice.id,
        data: this.dataOutput
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/InvoiceSubContractorEdit.vue